import { cellToBoundary, cellsToMultiPolygon } from 'h3-js'
import { Layer, Source } from 'react-map-gl'
import { PLOT_COLORS } from '#app/consts'
import { useStoreContext } from '#app/store'

export const PlotsOwned = () => {
	const loadedPlots = useStoreContext(s => s.loadedPlots)
	const highlightedPlotIds = useStoreContext(s => s.highlightedPlotIds)
	const highlightedPlotGroupIds = useStoreContext(
		s => s.highlightedPlotGroupIds,
	)

	const singlePlots = loadedPlots.filter(plot => plot.groupId === null)
	const groupedPlots = loadedPlots.filter(plot => plot.groupId !== null)

	// remove any duplicate single plots (dunno why)
	const uniquePlots = Array.from(
		new Set([
			...singlePlots.map(plot => plot.plotId),
			...highlightedPlotIds,
		]).values(),
	).map(plotId => {
		return { plotId }
	})

	// build and array of arrays of plotIds
	const groupedPlotIds = groupedPlots.map(plot => plot.groupId)
	const uniqueGroupIds = Array.from(new Set(groupedPlotIds).values())
	const groupedPlotIdArrays = uniqueGroupIds.map(groupId => {
		return groupedPlots
			.filter(plot => plot.groupId === groupId)
			.map(plot => plot.plotId)
	})

	return (
		<>
			{groupedPlotIdArrays.map(plotIds => {
				const multiplePlotsPolygon = cellsToMultiPolygon(plotIds, true)
				const groupId = loadedPlots.find(plot => plot.plotId === plotIds[0])
					?.groupId as string
				const isHighlighted = highlightedPlotGroupIds?.includes(groupId)

				const { highlightedFill, highlightedLine, ownedFill, ownedLine } =
					PLOT_COLORS

				return (
					<Source
						key={`grouped-${groupId}`}
						type="geojson"
						data={{
							type: 'FeatureCollection',
							features: [
								{
									type: 'Feature',
									geometry: {
										type: 'MultiPolygon',
										coordinates: multiplePlotsPolygon,
									},
									id: 'selected-plots',
									properties: {},
								},
							],
						}}
					>
						<Layer
							{...{
								id: `${groupId}-fill-layer`,
								type: 'fill',
								paint: {
									'fill-color': isHighlighted ? highlightedFill : ownedFill, //amber 600 and purple 600
									'fill-opacity': 0.22,
								},
							}}
						/>
						<Layer
							{...{
								id: `${groupId}-line-layer`,
								type: 'line',
								paint: {
									'line-color': isHighlighted ? highlightedLine : ownedLine, //amber 400 and purple 400
									'line-width': 1,
								},
							}}
						/>
					</Source>
				)
			})}

			{uniquePlots.map(({ plotId }) => {
				const coordinates = cellToBoundary(plotId, true)
				const isHighlighted = highlightedPlotIds?.includes(plotId)
				const isInGroup = groupedPlots.some(plot => plot.plotId === plotId)

				const {
					highlightedFill,
					highlightedLine,
					ownedFill,
					ownedLine,
					selectedLine,
				} = PLOT_COLORS

				const fillColor = isHighlighted
					? isInGroup
						? 'transparent'
						: highlightedFill
					: ownedFill
				const lineColor = isHighlighted
					? isInGroup
						? selectedLine
						: highlightedLine
					: ownedLine

				return (
					<Source
						key={`owned-${plotId}`}
						type="geojson"
						data={{
							type: 'FeatureCollection',
							features: [
								{
									type: 'Feature',
									geometry: {
										type: 'Polygon',
										coordinates: [coordinates],
									},
									id: plotId,
									properties: {},
								},
							],
						}}
					>
						<Layer
							{...{
								id: `${plotId}-fill-layer`,
								type: 'fill',
								paint: {
									'fill-color': fillColor,
									'fill-opacity': 0.22,
								},
							}}
						/>
						<Layer
							{...{
								id: `${plotId}-line-layer`,
								type: 'line',
								paint: {
									'line-color': lineColor,
									'line-width': 1,
								},
							}}
						/>
					</Source>
				)
			})}
		</>
	)
}
